import {
  SET_SELECTED_ARR,
  CLEAR_SELECTED_ARR,
} from "../constants/kulturprogram";

const initialState = {
  selectedArrangemangs: [],
};

export const kulturprogram = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_ARR:
      return {
        ...state,
        selectedArrangemangs: action.payload,
      };
    case CLEAR_SELECTED_ARR:
      return initialState;
    default:
      return state;
  }
};
